import { Location } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../services/login.service';
import { MenuService } from '../../services/menu.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Input() title: string;
  @Input() back;

  // title = 'Hacienda Amarillo';
  isLogged;
  constructor(
    private loginService: LoginService,
    private router: Router,
    private menu: MenuService,
    private location: Location
  ) {}

  ngOnInit() {
    this.isLogged = this.loginService.estaAutenticado();
  }

  logIn() {
    // this.isLogged = 'false';
    this.router.navigateByUrl('/login');
  }

  logOut() {
    this.loginService.logOut();
    this.router.navigateByUrl('/home');
  }

  open() {
    this.menu.openMenu();
  }

  goBack() {
    this.location.back();
  }
}
